import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';

import footerAdornment from '../../assets/images/FooterAdornment.svg'

const useStyles = makeStyles(theme => ({
    footer: {
        backgroundColor: theme.palette.common.blue,
        width: "100%",
        zIndex: 1302,
        position: "relative"
    },
    adornment: {
        width: "30em",
        verticalAlign: "bottom",
        [theme.breakpoints.down("xs")]: {
            width: "21em"
        },
        [theme.breakpoints.down("xs")]: {
            width: "15em"
        }
    },
    mainContainer: {
        position: "absolute"
    },
    link: {
        color: "white",
        fontFamily: 'IRANSans,Helvetica,sans-serif',
        fontSize: "0.9rem",
        fontWeight: "bold",
        textDecoration: "none !important",
    },
    gridItem: {
        margin: "3em",
    },
    icon: {
        height: "4em",
        width: "4em",
        [theme.breakpoints.down("xs")]: {
            height: "2.5em",
            width: "2.5em"
        }
    },
    socialContainer: {
        position: "absolute",
        marginTop: "-6em",
        right: "1.5em",
        [theme.breakpoints.down("xs")]: {
            right: "0.6em"
        }
    }
}))

export default function Footer(props) {
    const classes = useStyles();
    const content = props.content.footer;
    const language = props.language;
    const theme = useTheme();
    const matchesMD = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <footer className={classes.footer}>
            <Hidden xsDown>
                <Grid container direction="column" justify={matchesMD ? "flex-start" : "center"} className={classes.mainContainer} dir={language === "per" ? "rtl" : null}>

                    <Grid container direction="row" justify={matchesMD ? "flex-start" : "center"} dir={language === "per" ? "rtl" : null}>
                        <Grid item className={classes.gridItem}>
                            <Grid container direction="column" spacing={1}>
                                <Grid item component={Link} to="/" className={classes.link}>
                                    {content.col1_1}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item className={classes.gridItem}>
                            <Grid container direction="column" spacing={1}>
                                <Grid item component={Link} to="/services" className={classes.link}>
                                    {content.col2_1}
                                </Grid>
                                <Grid item component={Link} to="/network" className={classes.link}>
                                    {content.col2_2}
                                </Grid>
                                <Grid item component={Link} to="/hardware" className={classes.link}>
                                    {content.col2_3}
                                </Grid>
                                <Grid item component={Link} to="/learn" className={classes.link}>
                                    {content.col2_4}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item className={classes.gridItem}>
                            <Grid container direction="column" spacing={1}>
                                <Grid item component={Link} to="/about" className={classes.link}>
                                    {content.col3_1}
                                </Grid>
                                <Grid item component={Link} to="/contact" className={classes.link}>
                                    {content.col3_2}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container direction="row" justify={matchesMD ? "flex-start" : "center"} dir={language === "per" ? "rtl" : null} style={{ marginRight: matchesMD ? "5em" : null }}>
                        <Typography variant="caption" align="center" className={classes.link} style={{ fontSize: "0.7rem" }} >
                            {content.copyright}
                            <a href="https://fmcv.ir/" target="blank" style={{ textDecoration: "none", color: "white" }}>{content.designer}</a>
                            {content.year}
                        </Typography>
                    </Grid>
                </Grid>
            </Hidden>
            <img alt="black decorative slash" src={footerAdornment} className={classes.adornment} />
        </footer>
    )
}